import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { getPublishedNews } from '@/features/news/services/newsApi';
import type { NewsItem } from '@/features/news/services/newsApi';

export default function NewsFeed() {
  const { data: items, isLoading } = useQuery<NewsItem[]>({
    queryKey: ['news'],
    queryFn: () => getPublishedNews(5),
  });

  if (isLoading) return null;
  if (!items || items.length === 0) return null;

  return (
    <section className="mb-8">
      <h2 className="text-base font-bold mb-4 text-accent">Updates</h2>
      <hr />
      <div className="space-y-3 mb-6">
        {items.map((item) => (
          <div key={item.id}>
            <div className="text-sm">
              <span className="font-bold text-foreground">{item.title}</span>
              {item.created_at && (
                <span className="text-xs text-muted ml-2">
                  :: {format(new Date(item.created_at), 'yyyy.MM.dd')}
                </span>
              )}
            </div>
            <p className="text-sm text-muted mt-0.5 leading-relaxed m-0">{item.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
